import { render, staticRenderFns } from "./clipboard-text.vue?vue&type=template&id=62d67534&"
import script from "./clipboard-text.vue?vue&type=script&lang=js&"
export * from "./clipboard-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d67534')) {
      api.createRecord('62d67534', component.options)
    } else {
      api.reload('62d67534', component.options)
    }
    module.hot.accept("./clipboard-text.vue?vue&type=template&id=62d67534&", function () {
      api.rerender('62d67534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/clipboard-text.vue"
export default component.exports